import React, { useRef } from 'react';

//Estilos
import './ChangeOwnPassword.css';

function ChangeOwnPassword({ functions }) {
    const {
        register,
        control,
        handleSubmit,
        watch,
        setError,
        formState: { errors },
        onSubmit,
    } = functions;

    const password = useRef();
    password.current = watch('claveNueva');

    return (
        <form
            className="change_own_password-form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <label className="label-signup">
                <span>Clave Actual: </span>
                <input
                    className="signup-input"
                    type="password"
                    autoComplete="off"
                    {...register('claveActual', {
                        required: 'La clave actual es requerida',
                        minLength: {
                            value: 8,
                            message:
                                'La clave debe tener un mínimo de 8 caracteres',
                        },
                        pattern: {
                            value: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&#-]/,
                            message:
                                'La clave debe tener al menos una minúscula, una mayúscula, un número y un caracter especial [@$-!%*?&#]',
                        },
                    })}
                    onKeyPress={(e) => {
                        if (e.target.value.length > 20) {
                            e.preventDefault();
                        }
                    }}
                />
                {errors.claveActual && (
                    <small className="form__error">
                        {errors.claveActual.message}
                    </small>
                )}
            </label>
            <label className="label-signup">
                <span>Clave Nueva: </span>
                <input
                    className="signup-input"
                    type="password"
                    autoComplete="off"
                    {...register('claveNueva', {
                        required: 'La clave es nueva requerida',
                        minLength: {
                            value: 8,
                            message:
                                'La clave debe tener un mínimo de 8 caracteres',
                        },
                        pattern: {
                            value: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&#-]/,
                            message:
                                'La clave debe tener al menos una minúscula, una mayúscula, un número y un caracter especial [@$-!%*?&#]',
                        },
                    })}
                    onKeyPress={(e) => {
                        if (e.target.value.length > 20) {
                            e.preventDefault();
                        }
                    }}
                />
                {errors.claveNueva && (
                    <small className="form__error">
                        {errors.claveNueva.message}
                    </small>
                )}
            </label>
            <label className="label-signup">
                <span>Repita Nueva Clave: </span>
                <input
                    className="signup-input"
                    type="password"
                    autoComplete="off"
                    {...register('confirm_nueva_clave', {
                        required: 'Debe repetir su nueva clave',

                        validate: {
                            passwordMatch: (value) =>
                                value === password.current ||
                                'Las claves no coinciden',
                        },
                    })}
                    onKeyPress={(e) => {
                        if (e.target.value.length > 20) {
                            e.preventDefault();
                        }
                    }}
                />
                {errors.confirm_nueva_clave && (
                    <small className="form__error">
                        {errors.confirm_nueva_clave.message}
                    </small>
                )}
            </label>
            <button className="btn btn-primary">Cambiar</button>
        </form>
    );
}

export default ChangeOwnPassword;
